import Step from './Step';
import { useMemo } from 'react';
import styles from './styles.module.scss';
import { AffiliatesTermsStepperProps } from './props';
import { AffiliatesTermsStepProps } from './Step/props';
import useTranslation from 'next-translate/useTranslation';
import useAffiliatesTermsStepperVariant from '@/hooks/theme/variants/Affiliates/useAffiliatesTermsStepperVariant';

export default function AffiliatesTermsStepper({
  termsKey,
  isPaperBackground,
}: AffiliatesTermsStepperProps) {
  const { t } = useTranslation('affiliates');
  const { isV3Version } = useAffiliatesTermsStepperVariant();
  const terms = t(
    termsKey,
    {},
    {
      returnObjects: true,
    },
  ) as Record<string, AffiliatesTermsStepProps>;
  const Steps: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, i) => (
        <Step
          key={`affiliates_terms_hero_step_${i}`}
          title={t(terms[i + 1].title)}
          image={i + 1}
          description={t(terms[i + 1].description)}
          isPaperBackground={isPaperBackground}
        />
      )),
    [t, terms, isPaperBackground],
  );

  return (
    <div
      className={`${styles.container} ${isPaperBackground ? styles['container--paper'] : ''} ${isV3Version ? styles['container--v3'] : ''}`}
    >
      {Steps}
    </div>
  );
}
